export const PRODUCT_TYPE = {
  DENTAL: 'dental',
  VISION: 'vision',
} as const

export type PRODUCT_TYPE = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE]
